import { View } from 'backbone';
import jQuery from 'jquery';
import NProgress from 'nprogress';
import _ from 'underscore';
import Account from '../account';
import Spinner from '../spinner';

export default class InquiryFormView extends View {
    preinitialize() {
        this.spinner = new Spinner();

        this.events = {
            'focus .has-error': this.handleFocusErrorField,
            'click [data-action="back"]': this.handleClickBack,
            submit: this.handleSubmit,
        };
    }

    initialize(options) {
        this.inquiry_type = options.inquiry_type || null;
        this.building_id = Number(options.building_id) || null;
        this.unit_id = Number(options.unit_id) || null;
        this.notification_email = options.notification_email || null;
        this.page_url = options.page_url || null;
        this.page_title = options.page_title || null;
        this.google_site_key = options.google_site_key || null;

        this.api_client_id = options.api_client_id || null;
        if (this.api_client_id === null) {
            throw Error('Parameter api_client_id not set');
        }

        // Define message box
        this.msgBox = this.el.querySelector('[data-part="msg"]');
        if (this.msgBox === null) {
            console.warn('Container for messages not found');
        }

        // Populate inquiry form with Account data
        this.populateForm(Account.get());

        // If inquiry already sent for this building/unit; display message
        if (
            this.building_id &&
            Account.isPropertyInSentList(this.building_id, this.unit_id)
        ) {
            this.$el.find('form').empty();
            this.showMessageAlreadyReceived();
        }
    }

    handleFocusErrorField($e) {
        this.clearFieldError($e.currentTarget);
    }

    clearFieldError(field) {
        // Remove error class for this field
        field.classList.remove('has-error');

        // Hide any error messages
        this.clearMessages();
    }

    handleSubmit($e) {
        if ($e instanceof Object) {
            $e.preventDefault();
        }

        this.inquire();
    }

    inquire() {
        // Hide any error messages
        this.clearMessages();

        // Remove error class
        this.$el.find('.has-error').removeClass('has-error');

        const messageEl = this.el.querySelector('[name="message"]');
        let message;

        if (messageEl) {
            message = messageEl.value;
        } else {
            const inquiryTypeArray = [];
            const inquiryNodes = this.el.querySelectorAll('[data-inquiry]');

            inquiryNodes.forEach((el) => {
                if (el.checked) {
                    inquiryTypeArray.push(el.dataset.inquiry);
                }
            });

            if (inquiryTypeArray.length > 0) {
                message = inquiryTypeArray.join(', ');
            } else {
                message = 'General inquiry.';
            }
        }

        // Split name by spaces
        const splitName = this.el
            .querySelector('[name="name"]')
            .value.split(' ');

        // Use last segment as last name
        const lastName = splitName.pop();

        // Join remaining segments as first name
        const firstName = splitName.join(' ');

        const formData = {
            first_name: firstName,
            last_name: lastName,
            email: this.el.querySelector('[name="email"]').value,
            message,
            custom: {},
            meta: {},
        };

        const alertOk = this.el.querySelector('[name="alert_ok"]');
        if (alertOk) {
            formData.alert_ok = alertOk.checked ? 1 : 0;
        }

        // Add data initialized from view
        formData.type = this.inquiry_type;
        formData.building_id = this.building_id;
        formData.unit_id = this.unit_id;
        formData.meta.lang = HJ.Config.language;
        formData.meta.page_url = this.page_url;
        formData.meta.page_title = this.page_title;
        formData.meta.api_client_id = this.api_client_id;

        if (this.notification_email) {
            formData.meta.notification_email = this.notification_email;
        }

        // If Google Analytics is available
        if (window.ga && window.ga.getAll) {
            // Loop through trackers
            for (const tracker of window.ga.getAll()) {
                // If tracker has clientID; set in form data and break loop
                if (tracker.get('clientId')) {
                    formData.meta.ga_client_id = tracker.get('clientId');
                    break;
                }
            }
        }

        // If current URL has query string
        if (window.location.search) {
            // Parse URL query string
            const queryString = new URLSearchParams(window.location.search);

            // Add UTM source, medium, and campaign (if available)
            if (queryString.get('utm_source')) {
                formData.meta.utm_source = queryString.get('utm_source');
            }
            if (queryString.get('utm_medium')) {
                formData.meta.utm_medium = queryString.get('utm_medium');
            }
            if (queryString.get('utm_campaign')) {
                formData.meta.utm_campaign = queryString.get('utm_campaign');
            }
        }

        /**
         * Send inquiry
         */

        const submitBtn = this.el.querySelector('.submit-btn');
        this.spinner.spin(submitBtn);
        submitBtn.disabled = true;

        NProgress.start();

        window.grecaptcha.ready(() => {
            window.grecaptcha
                .execute(this.google_site_key, { action: 'inquiry_submit' })
                .then((token) => {
                    formData.recaptcha_token = token;
                    fetch(HJ.Config.api_url + '/inquiries', {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(formData),
                    })
                        .then((response) => {
                            if (response.ok) {
                                return response.json().then((data) => {
                                    NProgress.inc();

                                    // If top of inquiry form is not visible; scroll to top of inquiry form
                                    const offsetInquiryForm =
                                        this.$el.offset().top;
                                    if (
                                        offsetInquiryForm <
                                        jQuery(window).scrollTop() + 70
                                    ) {
                                        jQuery(window).scrollTop(
                                            offsetInquiryForm - 70
                                        );
                                    }

                                    // Save form field data for future use
                                    Account.save(
                                        _.pick(formData, ['name', 'email'])
                                    );

                                    Account.addPropertyToSentList(
                                        this.building_id,
                                        this.unit_id
                                    );

                                    // Send inquiry event to Google Analytics
                                    window.dataLayer &&
                                        window.dataLayer.push({
                                            event: 'inquiry',
                                            event_category: 'Inquiries',
                                            event_label:
                                                this.inquiry_type + ' inquiry',
                                            'phoenix.inquiry_type':
                                                this.inquiry_type,
                                            'phoenix.building_id':
                                                formData.building_id ||
                                                undefined,
                                            'phoenix.unit_id':
                                                formData.unit_id || undefined,
                                        });

                                    // Send conversion event to Google AdWords
                                    window.dataLayer &&
                                        window.dataLayer.push({
                                            event: 'conversion',
                                            send_to:
                                                'AW-1045793590/ymC0CMzy5QkQtpbW8gM',
                                        });

                                    // Remove form
                                    this.$el.find('form').empty();

                                    // Show success message
                                    this.showMessageSuccess();

                                    NProgress.done();

                                    return data;
                                });
                            } else {
                                return response.json().then((data) => {
                                    // Create and throw error
                                    const e = new Error(
                                        data.exception[0].message
                                    );
                                    e.name = data.exception[0].type;
                                    throw e;
                                });
                            }
                        })
                        .catch((e) => {
                            console.error(e);

                            // Show error message
                            this.showMessageErrorSend();
                        })
                        .finally(() => {
                            NProgress.done();
                            this.spinner.stop();
                            submitBtn.disabled = false;
                        });
                });
        });
    }

    handleClickBack() {
        window.history.back();
    }

    populateForm(data) {
        this.el.querySelector('[name="name"]').value = data.name || '';
        this.el.querySelector('[name="email"]').value = data.email || '';
    }

    showMessageErrorSend() {
        this.msgBox.innerHTML = this.el.querySelector(
            '#tmpl-msg-error-send'
        ).innerHTML;
    }

    showMessageErrorField() {
        this.msgBox.innerHTML = this.el.querySelector(
            '#tmpl-msg-error-field'
        ).innerHTML;
    }

    showMessageAlreadyReceived() {
        this.msgBox.innerHTML = this.el.querySelector(
            '#tmpl-msg-info-already-received'
        ).innerHTML;
    }

    showMessageSuccess() {
        this.msgBox.innerHTML = this.el.querySelector(
            '#tmpl-msg-success-send'
        ).innerHTML;
    }

    clearMessages() {
        this.msgBox.innerHTML = '';
    }
}
